var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"d-flex col-12"},[_c('div',{staticClass:"form-control-label",staticStyle:{"white-space":"pre-line"}},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('videos',{attrs:{"videos":_vm.content.data.videos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }